import Main from '@/views/administracion/configuracion/catalogos/insumos/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/insumos/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const insumos = [
  {
    path: 'insumos',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoInsumos',
        path: '/',
        meta: {
          title: 'Insumos',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default insumos;
